var hasRespondedToSubmitSurvey = function hasRespondedToSubmitSurvey(plan) {
  return !!(plan !== null && plan !== void 0 && plan.submitSurveyResponded);
};
export default hasRespondedToSubmitSurvey;